import Store from '@/store'
import Fuse from 'fuse.js';

const putil = {
    ProductCategoryList: ["Commodites","Forex","Index","USStock","HKStock","Crypto"],
    ProductData:{
        "Commodites": [22, 602, 23, 605, 351, 671, 352, 359, 450, 626, 521, 520, 451, 522, 598, 621, 528, 703, 702, 599, 673, 449, 523, 452, 607, 645, 646, 647,],
        "Forex": [526, 489, 110, 118, 105, 487, 112, 115, 444, 114, 113, 108, 445, 580, 606, 117, 446, 116, 109, 447, 103, 120, 527, 488, 111, 106, 107, 104, 119, 102, 603,],
        "Index": [353, 614, 354, 613, 355, 356, 357, 604, 358, 525, 624, 530, 672, 532, 364, 361, 362, 904, 674, 612, 620, 597, 363, 529, 360, 427, 431,],
        "USStock": [413, 575, 435, 633, 873, 856, 479, 414, 867, 709, 472, 439, 862, 859, 858, 434, 866, 475, 863, 632, 616, 473, 615, 869, 471, 857, 861, 860, 868, 864, 870, 438, 576, 871, 872, 865,],
        "HKStock": [882, 706, 412, 461, 874, 883, 879, 432, 636, 708, 877, 878, 880, 881, 637, 496, 884, 875, 638, 876, 885, 707, 705,],
        "Crypto": [654, 551, 557, 556, 538, 650, 536, 595, 670, 608, 669, 547, 545, 549, 423, 537, 596, 609, 666, 554, 663, 568, 543, 550, 539, 566, 665, 558, 548, 544, 652, 655, 667, 542, 664, 553, 651, 541,]
    },
    getProductsByCategory: function(category) {
        const productSourceCodes = putil.ProductData[category] || [];
        const items = productSourceCodes.map(code => {
            return Store.state.quote.sourceNotify[code];
        }).filter(item => item !== undefined);
        return items;
    },
    getProductList: function() {
        return putil.ProductCategoryList.reduce((products, category) => {
            const items = putil.getProductsByCategory(category) || [];
            if (items.length) products.push(...items);
            return products;
        }, []);
    },
    fuzzySearch: function (searchText) {
        const list = putil.getProductList() || [];
        if (!searchText || !searchText.trim()) return list;

        const options = {
            keys: ['szShortName'],
            ignoreLocation: false,
            minMatchCharLength: 1,
            includeScore: true,
        };

        try {
            const fuse = new Fuse(list, options);
            const results = fuse.search(searchText);

            // filter out results, then return the item objects
            const filtered = results
                .filter(r => {
                    // result may be { item, score } when includeScore is true
                    if (r && typeof r === 'object' && 'score' in r) {
                        return r.score < 0.4;
                    }
                    return true;
                })
                .map(r => (r && r.item) ? r.item : r);

            return filtered;
        } catch (e) {
            // on error, fallback to full list
            return list;
        }       
    }

}

export default putil;